import flatpickr from "flatpickr";

document.addEventListener('DOMContentLoaded', function () {
  flatpickrSetup();
});

document.addEventListener('turbo:load', function () {
  flatpickrSetup();
});

function flatpickrSetup() {
  flatpickr('.flatpickr', {
    dateFormat: "Y-m-d",
  });
  flatpickr('.flatpickr-range', {
    dateFormat: "Y-m-d",
    mode: "range"
  });
}
